import { UseFormReturn, RegisterOptions } from 'react-hook-form';

export type FormProps = Pick<
    UseFormReturn,
    'clearErrors' | 'control' | 'register' | 'setValue' | 'watch' | 'formState'
> & { formDisabled?: boolean };

export type Validate = (value: string) => string | { [key: string]: (value: string) => string };

export enum Validator {
    MAX = 'max',
    MAX_LENGTH = 'maxLength',
    MIN = 'min',
    MIN_LENGTH = 'minLength',
    PATTERN = 'pattern',
    REQUIRED = 'required',
    VALIDATE = 'validate',
}

export type Validators = RegisterOptions;

export type ValidatorValue = boolean | number | string | RegExp;

export interface LengthValidator {
    value: ValidatorValue;
    message: string;
}
